var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EF476F",
    d: "M157.74 151.006h67.086a4.862 4.862 0 0 1 4.852 4.852V344.19a4.862 4.862 0 0 1-4.852 4.852H157.74a4.862 4.862 0 0 1-4.852-4.852V155.858a4.863 4.863 0 0 1 4.852-4.852z",
    opacity: 1,
    "data-original": "#EF476F"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD166",
    d: "M274.946 151.006h67.086a4.862 4.862 0 0 1 4.852 4.852v67.086a4.862 4.862 0 0 1-4.852 4.852h-67.086a4.862 4.862 0 0 1-4.852-4.852v-67.086a4.861 4.861 0 0 1 4.852-4.852z",
    opacity: 1,
    "data-original": "#FFD166"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06D6A0",
    d: "M274.946 272.253h67.086a4.862 4.862 0 0 1 4.852 4.852v67.086a4.862 4.862 0 0 1-4.852 4.852h-67.086a4.862 4.862 0 0 1-4.852-4.852v-67.086a4.86 4.86 0 0 1 4.852-4.852z",
    opacity: 1,
    "data-original": "#06D6A0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M432.4 203.02c-2.557-2.515-6.626-2.515-9.125 0-2.499 2.505-2.499 6.57 0 9.086l37.894 37.893-37.894 37.887c-4.051 4.064-1.11 10.968 4.533 10.968a6.476 6.476 0 0 0 4.592-1.883l42.427-42.43c2.499-2.513 2.499-6.579 0-9.085zM67.644 296.971c2.421 2.495 6.587 2.521 9.066 0 2.499-2.506 2.499-6.57 0-9.085l-37.894-37.887 37.894-37.893c2.499-2.515 2.499-6.581 0-9.086a6.39 6.39 0 0 0-9.066 0l-42.427 42.436c-2.558 2.54-2.555 6.541 0 9.085zm208.997 45.621h63.931v-63.94h-63.931zm-12.845-65.518c0-6.214 5.056-11.27 11.275-11.27h67.07c6.219 0 11.275 5.056 11.275 11.27v67.089c0 6.213-5.056 11.278-11.275 11.278h-67.07c-6.219 0-11.275-5.065-11.275-11.278zm12.845-55.726h63.931v-63.942h-63.931zm-12.845 1.569v-67.089c0-6.214 5.056-11.27 11.275-11.27h67.07c6.219 0 11.275 5.056 11.275 11.27v67.089c0 6.214-5.056 11.279-11.275 11.279h-67.07c-6.218 0-11.275-5.065-11.275-11.279zM159.414 342.592h63.931V157.406h-63.931zm-1.569 12.85c-6.219 0-11.275-5.065-11.275-11.278V155.828c0-6.214 5.056-11.27 11.275-11.27h67.07c6.219 0 11.333 5.056 11.333 11.27v188.336c0 6.213-5.114 11.278-11.333 11.278zM470.294 112.94h-70.382v244.155c0 3.55-2.906 6.425-6.451 6.425s-6.393-2.874-6.393-6.425V112.94h-244.16c-3.545 0-6.451-2.872-6.451-6.425 0-3.542 2.906-6.425 6.451-6.425h244.159V29.734c0-3.551 2.848-6.423 6.393-6.423s6.451 2.872 6.451 6.423v70.356h70.382c3.545 0 6.393 2.883 6.393 6.425.001 3.553-2.847 6.425-6.392 6.425zM363.528 393.474c0 3.544-2.906 6.425-6.393 6.425H112.977v70.365c0 3.544-2.906 6.425-6.451 6.425s-6.393-2.881-6.393-6.425v-70.365H29.75c-3.545 0-6.451-2.881-6.451-6.425 0-3.551 2.906-6.422 6.451-6.422h70.382V142.896c0-3.554 2.848-6.425 6.393-6.425s6.451 2.872 6.451 6.425v244.155h244.159c3.488 0 6.393 2.872 6.393 6.423z",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomize);
export default __webpack_public_path__ + "static/media/customize.c652a30a2c307c9498254775fd262fc2.svg";
export { ForwardRef as ReactComponent };